import { useCallback, useState } from 'react';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';
import { normalizeTextColor } from 'shared/utils/richText';
import { withUsedTextColor } from './model';

interface TextColorHistory {
  /** Colours the user used, newest first; the first is what the "A" applies. */
  used: string[];
  remember: (color: string) => void;
  /** Reads again what another editor stored meanwhile. */
  reload: () => void;
}

function readStoredUsedColors(): string[] {
  return LocalStorageManager.getRecentTextColors()
    .map((color) => normalizeTextColor(color))
    .filter((color): color is string => Boolean(color));
}

/** The colours the user used last (PT-7250), kept per user in local storage and shared by every editor. */
export function useTextColorHistory(): TextColorHistory {
  const [used, setUsed] = useState(readStoredUsedColors);

  const remember = useCallback((color: string) => {
    const updated = withUsedTextColor(readStoredUsedColors(), color);
    LocalStorageManager.setRecentTextColors(updated);
    setUsed(updated);
  }, []);

  const reload = useCallback(() => {
    setUsed(readStoredUsedColors());
  }, []);

  return { used, remember, reload };
}
